<template>
  <div class="user-page full-height">
    <tableCon>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/canBoxOrders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>可装箱订单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="4" class="display-row">
            <div class="query-title" style="text-align:right;width: 120px;">用户ID:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.customerUserName"
                  size="small"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">用户名:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.customerRealName" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">下单开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.orderTimeStart" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                              placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">下单结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.orderTimeEnd" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                              placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>

          <el-col :span="5" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
<!--              <el-button class="search-btn btn-green" @click="exportAction">导出</el-button>-->
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table ref="multipleTable" :data="orderList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle"
          v-loading="isLoading" border stripe style="width: 100%" height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>

           <el-table-column prop="customerUserId" align="center" label="用户信息"  width="300" :index="indexMethod" >
             <template v-slot="scope">
               <div >
                 <!-- <div class="overflowDot" :title="scope.row.logisticeCompany">{{scope.row.logisticeCompany}}</div> -->
                 <!-- <div>{{scope.row.recipientName}}</div>
                 <div>{{scope.row.zipCode}}</div>
                 <div>{{scope.row.deliveryAddress}}</div> -->
                 <div>
                   <span>{{scope.row.customerUserName}}</span>
                 </div>
                 <div>
                   <span>{{scope.row.customerRealName}}</span>
                 </div>
                 <div>
                   <span>{{scope.row.remarkCustomerName}}</span>
                 </div>
                 <!-- <div class="overflowDot" :title="scope.row.logisticeState">{{scope.row.logisticeState}}</div> -->
               </div>

             </template>
           </el-table-column>
            <el-table-column prop="receiver" label="收货信息" :index="indexMethod"  sortable  >
              <template v-slot="scope">
                <div >
                  <!-- <div class="overflowDot" :title="scope.row.logisticeCompany">{{scope.row.logisticeCompany}}</div> -->
                  <!-- <div>{{scope.row.recipientName}}</div>
                  <div>{{scope.row.zipCode}}</div>
                  <div>{{scope.row.deliveryAddress}}</div> -->
                  <div>
                    <span>收件人：</span>
                    <span>{{scope.row.receiver}}</span>
                  </div>
                  <div>
                    <span>收件人邮编：</span>
                    <span>{{scope.row.zipCode}}</span>
                  </div>
                  <div>
                    <span>收件地址：</span>
                    <span>{{scope.row.receiverAddress}}</span>
                  </div>
                  <!-- <div class="overflowDot" :title="scope.row.logisticeState">{{scope.row.logisticeState}}</div> -->
                </div>

              </template>
            </el-table-column>
            <el-table-column prop="waitBoxCount" label="订单信息" :index="indexMethod"  sortable  >
              <template v-slot="scope">
                <div >
                  <!-- <div class="overflowDot" :title="scope.row.logisticeCompany">{{scope.row.logisticeCompany}}</div> -->
                  <!-- <div>{{scope.row.recipientName}}</div>
                  <div>{{scope.row.zipCode}}</div>
                  <div>{{scope.row.deliveryAddress}}</div> -->
                  <div>
                    <span>总数量：</span>
                    <span>{{scope.row.goodsCount }}</span>
                  </div>
                  <div>
                    <span>未装箱数：</span>
                    <span>{{scope.row.waitBoxCount + scope.row.refundCount}}</span>
                  </div>
                  <div>
                    <span>可装箱数：</span>
                    <span>{{scope.row.waitBoxCount}}</span>
                  </div>
                  <div>
                    <span>退货数：</span>
                    <span>{{scope.row.refundCount}}</span>
                  </div>
                  <!-- <div class="overflowDot" :title="scope.row.logisticeState">{{scope.row.logisticeState}}</div> -->
                </div>

              </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </tableCon>

    <!-- <MessageTip :visiable.sync="replyDialogVisible" :userName="replyMessageInfo.userName" messageType="订单消息"
      :orderNo="replyMessageInfo.id" httpUrl="cms/inBox/reply" @confirm="onConfirmMsg"></MessageTip> -->
    <MessageTip :visiable.sync="replyDialogVisible" :info="replyMessageInfo" @confirm="onConfirmMsg"></MessageTip>

  </div>
</template>

<script>
import { columns as originColumns } from "./storageOrdersColumns";
import LxSort from "@/components/LxSort/index";
import Oss from "../../assets/js/oss.js";
import tableCon from "../../views/tableContainer";
import MessageTip from '@/components/MessageTip/index'
export default {
  name: 'canBoxOrders',
  // name: 'order/StorageOrders',
  components: {
    LxSort,
    tableCon, MessageTip
  },
  data () {
    return {
      isActive:false,
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      isVisibleSort: false,
      originColumns, // 初始表头

      orderList: [],
      menuSettingData: {
        menuId: 'canBoxOrders'
      },
      visible: false,
      queryInfo: {
        customerUserName: '',
        customerRealName: '',
        orderTimeStart: '',
        orderTimeEnd: '',
        pageSize: 10,
        pageNum: 1,
      },

      total: 0,
      // picture end
      scrollListener: null,
      scrollTopCache: 0
    };
  },
  created () {

    this.searchList();
  },
  methods: {
    // picture Ctrl+V start

    onConfirmMsg () {
      this.replyDialogVisible = false
      this.getOrderList()
    },


    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    queryInfoClear () {
      this.queryInfo = {
        customerUserName: '',
        customerRealName: '',
        orderTimeStart: '',
        orderTimeEnd: '',
        pageSize: 10,
        pageNum: 1,
      }
      // this.orderDateRangeValue = '';
      // this.shipDateRangeValue = [];
    },
    searchList () {
      this.queryInfo.pageNum = 1;
      this.getOrderList();
    },

    async getOrderList () {
      this.isLoading = true;
      const { data: res } = await this.$http.post("shop/order/canBoxOrderList", this.queryInfo);
      this.orderList = res.data.list;
      this.total = res.data.total;
      this.isLoading = false;
    },




    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getOrderList();
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getOrderList();
    }

  },
  watch: {

  },
  computed: {
    order1 () {
      if (!sessionStorage.getItem('token')) {
        return false;
      }
    }
  },
  mounted () {
    this.restoreScroll()
  },
  activated () {
    this.restoreScroll()
  },
  // 离开页面
  deactivated() {
    const bodyWrapper = this.$refs.multipleTable.$el.querySelector('.el-table__body-wrapper');
    bodyWrapper.removeEventListener('scroll', this.scrollListener);
  }
};
</script>

<style lang="less" scoped>
.paste-img {
  position: absolute;
  top: 0;
  left: 1px;
  width: 1px;
  height: 1px;
  z-index: 999;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}
.div{
  display: flex;
  width: 100%;
  .table-cell-title-min-new{
    display: block;
    width: 70px;
    text-align: right;
  }
  .span{
    flex: 1;
    text-align: left;
  }
}

</style>
<style lang="less" scoped>
/deep/ /*去除upload组件过渡效果*/
.el-upload-list__item {
  transition: none !important;
}
.bigimg /deep/ ul li {
  width: 100%;
  height: auto;
}
.bigimg /deep/ .el-upload--picture-card {
  display: none;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.search-btn-container-status {
  text-align: left !important;
}
.mark {
  background: #dbdb86;
  text-align: left;
  margin-bottom: 10px;
}
.el-icon-close {
  cursor: pointer;
}
</style>
